import React, { FC, PropsWithChildren } from 'react';
import { ProductionFuntipSystemConfig } from '../../System/systemConfig';
import { ShowWhenTenant } from '../ShowWhenTenant';

export const ShowWhenFuntip: FC<PropsWithChildren<{}>> = props => (
    <ShowWhenTenant tenantId={String(ProductionFuntipSystemConfig.clientId)} {...props} />
);
